import React from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import HeroBannerContent from "../../molecules/HeroBannerContent";
import Breadcrumb from "../../molecules/Breadcrumb";
import useIsMobile from "../../../hooks/useIsMobile";

import "./hero-banner.m.css";

const HeroBanner = ({
  backgroundImage,
  breadcrumbs,
  title,
  eventInfo,
  buttons,
  storyUrl,
  ...props
}) => {
  const isMobile = useIsMobile();
  const fallbackImageFromConfig = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "events_fallback"], "")
  );

  const heroImage = backgroundImage || fallbackImageFromConfig;

  if (isMobile) {
    return (
      <div styleName="hero-banner mobile" {...props}>
        <div styleName="mobile-image-section">
          <div
            styleName="background-image"
            style={{ backgroundImage: `url(${heroImage})` }}
          />
          <div styleName="mobile-breadcrumb">
            {breadcrumbs && <Breadcrumb items={breadcrumbs} />}
          </div>
        </div>
        <HeroBannerContent
          title={title}
          eventInfo={eventInfo}
          buttons={buttons}
          storyUrl={storyUrl}
          isMobile={true}
        />
      </div>
    );
  }

  return (
    <div styleName="hero-banner desktop" {...props}>
      <div
        styleName="background-image"
        style={{ backgroundImage: `url(${heroImage})` }}
      />
      <HeroBannerContent
        breadcrumbs={breadcrumbs}
        title={title}
        eventInfo={eventInfo}
        buttons={buttons}
        storyUrl={storyUrl}
        isMobile={false}
      />
    </div>
  );
};

export default HeroBanner;